import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import ListTable from '../../../common/tables/ListTable';
import TableDefinitions from '../../../common/TableDefinitions';
import OperatorSelectionCriteriaContainer
  from '../../../common/selection-criteria/operator-impc/container/OperatorSelectionCriteriaContainer';
import { getColumns, getData, getIsLoading } from '../redux/selectors/MemberPoolStorageListSelectors';
import { tableClickedRowSetSuccess, tableLoadData } from '../../../common/tables/actions/ListTableActions';
import { getAssetType } from '../../../common/asset-types/redux/selectors/AssetTypesSelectors';
import { getLeftCheckedPostalOperators } from '../../../common/user/redux/selectors/UserDataSelectors';
import MemberPoolStorageEditContainer from './MemberPoolStorageEditContainer';
import DownloadTypes from '../../../common/tables/excel/DownloadTypes';
import { MemberPoolStorageStyle } from './MemberPoolStorageListContainer.styles';
import { getClickedRowOnTable } from '../../../common/tables/reducers/selectors/ListTableSelectors';

class MemberPoolStorageListContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showResult: false,
      selectedRow: null,
    };
  }

  onCriteriaApply = () => {
    this.setState({
      showResult: true,
      selectedRow: null,
    });

    this.props.tableLoadData(
      { tableId: 'MEMBER_POOL_STORAGE_PAGE' },
      this.props.appContext.appContext,
      this.props.checkedPostalOperators,
    );
  };

  onSelectRow = (state, rowInfo) => {
    if (rowInfo && rowInfo.row) {
      if (rowInfo.index === 0) {
        this.setState({
          selectedRow: rowInfo.row,
        });
        this.props.tableClickedRowSetSuccess(rowInfo.row);
      }
      return {
        onClick: () => {
          if (this.state.selectedRow === null || rowInfo.row.operatorCode !== this.state.selectedRow.operatorCode) {
            this.setState({
              selectedRow: rowInfo.row,
            });
          } else {
            this.setState({
              selectedRow: null,
            });
          }
          this.props.tableClickedRowSetSuccess(rowInfo.row);
        },
        style: {
          cursor: 'pointer',
        },
      };
    }
    return {};
  };

  onEditCancel = () => {
    this.setState({
      selectedRow: null,
    });
  };

  render() {
    const { showResult, selectedRow } = this.state;
    const {
      data,
      isLoading,
      columns,
    } = this.props;
    const { _index: index } = this.props.clickedRow || { _index: -1 };
    return (
      <div>
        <OperatorSelectionCriteriaContainer
          open={data.length === 0}
          title="MEMBER POOL STORAGE"
          onApply={this.onCriteriaApply}
        />
        <div className="general-content-container">
          {(showResult || data.length > 0) && (
            <>
              <div className="general-half-left-container">
                <MemberPoolStorageStyle selectedRowIndex={index}>
                  <ListTable
                    listId={TableDefinitions.MEMBER_POOL_STORAGE_PAGE.id}
                    loading={isLoading}
                    columns={columns}
                    data={data}
                    keyField="id"
                    getTrProps={this.onSelectRow}
                    downloadType={DownloadTypes.EXCEL}
                    selectCheckbox
                    pagination
                  />
                </MemberPoolStorageStyle>
              </div>
              {selectedRow && (
                <div className="general-half-right-container">
                  <MemberPoolStorageEditContainer
                    operatorCode={selectedRow.operatorCode}
                    trayStorageCount={selectedRow.trayStorageCount}
                    palletStorageCount={selectedRow.palletStorageCount}
                    onCancel={this.onEditCancel}
                  />
                </div>
              )}
            </>
          )}
        </div>
      </div>
    );
  }
}

MemberPoolStorageListContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  appContext: PropTypes.objectOf(PropTypes.string),
  checkedPostalOperators: PropTypes.arrayOf(PropTypes.string),
  tableLoadData: PropTypes.func,
  tableClickedRowSetSuccess: PropTypes.func,
  isLoading: PropTypes.bool,
  clickedRow: PropTypes.objectOf(PropTypes.any),
};

function mapStateToProps(state) {
  return {
    data: getData(state),
    columns: getColumns(state),
    appContext: getAssetType(state),
    checkedPostalOperators: getLeftCheckedPostalOperators(state),
    isLoading: getIsLoading(state),
    clickedRow: getClickedRowOnTable(state),
  };
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  tableLoadData,
  tableClickedRowSetSuccess,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(MemberPoolStorageListContainer);
